import { render, staticRenderFns } from "./putInDetail.vue?vue&type=template&id=7497d340&scoped=true"
import script from "./putInDetail.vue?vue&type=script&lang=js"
export * from "./putInDetail.vue?vue&type=script&lang=js"
import style0 from "./putInDetail.vue?vue&type=style&index=0&id=7497d340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7497d340",
  null
  
)

export default component.exports